import React, { Fragment, useEffect, useState } from "react";
import { useBrandsQuery } from "../../../services/brandApi";

import Select from "react-select";
import { signInUser } from "../../Utility/Auth";

const SelectBrand = ({ handleOnchange, brand }) => {
  const auth = signInUser();
  const {aamarId} = auth;
  const { data, error, isLoading, isFetching, isSuccess } = useBrandsQuery({aamarId});
  let [brandData, setBrandData] = useState([]);

  useEffect(() => {
    let brandList = [];
    if (isSuccess) {
      if (data.length > 0) {
        data.map((brand) => {
          brandList = [
            ...brandList,
            {
              option: brand._id,
              label: `${brand.name}`,
            },
          ];
        });
        // console.log("brandList", brandList);
        setBrandData(brandList);
      }
    }
  }, [data]);

  // console.log("brand Id", brand,brandData );
  // console.log(mcData.filter((sel) => sel?.option?.toString() === supplier_code?.toString()))
  // console.log(mcData.indexOf(mc));
  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={brandData[0]}
        value={
          brand && brandData[brandData.map((obj) => obj.option).indexOf(brand)]
        }
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={true}
        onChange={(e) => handleOnchange(e)}
        options={brandData}
      />

      <div
        style={{
          color: "hsl(0, 0%, 40%)",
          display: "inline-block",
          fontSize: 12,
          fontStyle: "italic",
          marginTop: "1em",
        }}
      ></div>
    </Fragment>
  );
};

export default SelectBrand;
